const OMNI_SEARCH_DATASOURCE = 'index_ds_d71d6026';

function getFunLinkSdk() {
  if (typeof window === 'undefined' || !window.FUN_LINK_SDK) {
    return Promise.reject({
      status: -1,
      msg: 'Fun Link SDK 未加载'
    });
  }

  return Promise.resolve(window.FUN_LINK_SDK);
}

function getResponseData(response) {
  if (response.status !== 0 /*非成功返回*/) {
    return Promise.reject(response);
  }

  return response.data;
}

function normalizePositionData(data) {
  if (!Array.isArray(data?.items)) {
    return data;
  }

  return data.items.reduce((positionMap, positionItem) => {
    const positionId = positionItem.position || positionItem.positionId;
    if (!positionId) {
      return positionMap;
    }

    positionMap[positionId] = (positionItem.dataSource || []).reduce((dataSourceMap, dataSourceItem) => {
      const dataSourceId = dataSourceItem.datasource || dataSourceItem.datasourceId;
      if (!dataSourceId) {
        return dataSourceMap;
      }

      const { datasource, datasourceId, ...dataSourceData } = dataSourceItem;
      dataSourceMap[dataSourceId] = dataSourceData;
      return dataSourceMap;
    }, {});
    return positionMap;
  }, {});
}

/**
 *  获取omni数据
 * @param {*} postion 分发位置
 * @returns
 */
export function getOmniData(postion, dataSources) {
  return getFunLinkSdk()
    .then(sdk =>
      sdk.getOmniPositionData({
        param: {
          lang: 'zh-Hans',
          positions: [
            {
              dataSources: dataSources,
              position: postion
            }
          ]
        }
      })
    )
    .then(getResponseData)
    .then(normalizePositionData)
    .then(data => data?.[postion]);
}

export function getOmniDetail(contentId) {
  return getFunLinkSdk()
    .then(sdk =>
      sdk.getOmniDetail({
        param: {
          lang: 'zh-Hans',
          contentId: contentId
        }
      })
    )
    .then(getResponseData)
    .then(data => data?.content || data?.[contentId]);
}

export const getOmniSearch = ({ keywords, categoryId = '', page = 1, pageSize = 12 }) => {
  const params = {
    _omni_withDict: true,
    _omni_aggField: 'categoryId',
    _omni_text: keywords,
    page,
    pageSize
  };
  if (categoryId) {
    params.categoryId = categoryId;
  }

  return getFunLinkSdk()
    .then(sdk => sdk.getOmniSearchDatasource(OMNI_SEARCH_DATASOURCE, params))
    .then(getResponseData);
};

export const KvDownloadChannelId = 'channel_cat_8ae9f08e';
export const KvDownloadId = 'ds_cat_64422aa5';
export const KvUtmsourceDownloadId = 'ds_cat_aa5b92de';

export const KvIds = {
  // ds_cat_eee26b99: 'KV',
  // ds_cat_8f98015d: '游戏阶段信息',
  // ds_cat_64422aa5: '下载渠道配置-自定义渠道',
  // ds_cat_aa5b92de: '下载渠道配置-默认渠道'MainKvStore
  kv: 'ds_cat_eee26b99',
  stage: 'ds_cat_8f98015d',
  custom_download: 'ds_cat_64422aa5',
  default_download: 'ds_cat_aa5b92de'
};

export const NewsImgId = 'ds_cat_e490b7bd';
export const NewsTopDataId = 'ds_cat_f4244f78';
export const NewsChannelId = 'channel_cat_e9f08e88';

export const newData = [
  { title: '最新', spaceTitle: '最&nbsp;&nbsp;新', id: 'ds_cat_b996545c' },
  { title: '新闻', spaceTitle: '新&nbsp;&nbsp;闻', id: 'ds_cat_5c6a3116' },
  { title: '公告', spaceTitle: '公&nbsp;&nbsp;告', id: 'ds_cat_16359372' },
  { title: '活动', spaceTitle: '活&nbsp;&nbsp;动', id: 'ds_cat_72189bb8' }
];
export const FeatureChannelId = 'channel_cat_f08e881b';
export const FeatureImgId = 'ds_cat_b894ce49';

export const SchoolChannelId = 'channel_cat_8e881bee';
export const SchoolImgId = 'ds_cat_a15680ad';

export const StrategyImgId = 'ds_cat_77036ec5';
export const StrategyChannelId = 'channel_cat_881beee2';

export const AuditionVideoChannelId = 'channel_cat_1beee26b';

export const AuditionVideoId = 'ds_cat_ec519566';

export const AuditionImageId = 'ds_cat_eb033770';

export const AuditionAudioId = 'ds_cat_5665b05c';

export const strategy = {
  ds_cat_1d928b4b: {
    title: '最新',
    spaceTitle: '最&nbsp;&nbsp;新',
    categoryId: ''
  },
  ds_cat_c19c1ad2: {
    title: '新手',
    spaceTitle: '新&nbsp;&nbsp;手',
    categoryId: 'sqrihgmc2yo1'
  },
  ds_cat_ad2344d7: {
    title: '门派',
    spaceTitle: '门&nbsp;&nbsp;派',
    categoryId: 'sqrihphz37k2'
  },
  ds_cat_fd05e1f7: {
    title: '玩法',
    spaceTitle: '玩&nbsp;&nbsp;法',
    categoryId: 'sqrii0cn7if5'
  },
  ds_cat_f7340f6f: {
    title: '进阶',
    spaceTitle: '进&nbsp;&nbsp;阶',
    categoryId: 'sqrii98a7rb5'
  }
};

export const findKeyByTitle = (title, data) => {
  const entry = Object.entries(data).find(([key, value]) => value.title === title);
  return entry ? entry[0] : null;
};
